export default function PaymentRedirectController(
    $scope,
    $location,
    Bookings,
    ENV,
    paymentService
) {
    const notifications = {
        missingUidParam: {
            id: "missing-uid-param",
            type: "error",
            message: "Fejl i url",
        },
        noBookingFound: {
            id: "no-booking-found",
            type: "error",
            message: "Din booking blev ikke fundet",
        },
        paymentGatewayDisabled: {
            id: "payment-gateway-disabled",
            type: "info",
            message: "Payment is disabled in this environment - " + ENV.type,
        },
    };

    $scope.notification = {
        type: null,
        message: null,
    };

    $scope.envType = ENV.type;
    $scope.paymentGatewayEnabled = ENV.payment.enabled;
    $scope.notifications = notifications;

    if ($scope.paymentGatewayEnabled) {
        $scope.notification = notifications.paymentGatewayDisabled;
    }

    const url = new URL(window.location.href);
    const uid = url.searchParams.get("uid");
    const receiptPageRoute = "/checkout/payment-receipt";
    $scope.receiptPageRoute = receiptPageRoute;

    if (!uid) {
        $scope.notification = notifications.missingUidParam;
    }

    $scope.uid = uid;

    $scope.proceed = () => {
        initPayment();
    };

    const initPayment = () => {
        // If organization skip card payment and go to receipt
        if (ENV.payment.enabled == false) {
            $location.path(receiptPageRoute);
        } else {
            paymentService.create($scope.bookingId).then((result) => {
                window.location = result.hostedPaymentPageUrl;
            });
        }
    };

    Bookings.getByUid(uid).then((booking) => {
        if (booking) {
            $scope.bookingId = booking.id;
            initPayment();
        } else {
            $scope.notification = notifications.noBookingFound;
        }
    });
}
